import React, { Suspense } from "react";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";

// Lazy load the desktop and mobile components
const DesktopEventView = React.lazy(() => import("./dayEventView_desktop"));
const MobileEventView = React.lazy(() => import("./dayEventView_mobile"));

const EventScheduler = ({ events, getEventsForHour, bookItOrCreateRef, showTimeSlots, BookItOrCreate , currentDate}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if the device is mobile

    return (
        <Suspense fallback={<div>Loading...</div>}>
            {isMobile ? (
                <MobileEventView
                    events={events}
                    getEventsForHour={getEventsForHour}
                    bookItOrCreateRef={bookItOrCreateRef}
                    BookItOrCreate={BookItOrCreate}
                    currentDate ={currentDate}
                />
            ) : (
                <DesktopEventView
                    events={events}
                    getEventsForHour={getEventsForHour}
                    bookItOrCreateRef={bookItOrCreateRef}
                    showTimeSlots={showTimeSlots}
                    BookItOrCreate={BookItOrCreate}
                />
            )}
        </Suspense>
    );
};

export default EventScheduler;
